const { mainSlick, regularSlick, goToTopHandler, isMobile } = layoutJS
new Vue({
  // root node
  el: '#main',
  // the instance state
  data: function () {
    return {
      yt_id: 'Gb1J2dc0czs', // test_id: 'Gb1J2dc0czs'
      banner_slides: [
        { link: '#', img_src: 'images/carousel/01.png' },
        { link: '#', img_src: 'images/carousel/01.png' },
        { link: '#', img_src: 'images/carousel/01.png' },
      ],
      banner_menu: [],
      root_current: null,
      main_current: null,
      sub_current: null,
      slick_setting3: {
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      slick_setting2_1: {
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      slick_setting2: {
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 849,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      },
      subject_length: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0,
        25: 0,
        26: 0,
        27: 0,
        28: 0,
        29: 0,
      },
      current_subject: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        11: 0,
        12: 0,
        13: 0,
        14: 0,
        15: 0,
        16: 0,
        17: 0,
        18: 0,
        19: 0,
        20: 0,
        21: 0,
        22: 0,
        23: 0,
        24: 0,
        25: 0,
        26: 0,
        27: 0,
        28: 0,
        29: 0,
      },
    }
  },
  computed: {
    // get only
    main_current_list: function () {
      const current_arr = this.banner_menu.filter((item) => {
        return item.name === this.root_current // 取得陣列中雙數的物件
      })
      return current_arr && current_arr[0]
    },
    current_hotProducts: function () {
      const current_arr = this.banner_menu.filter((item) => {
        return item.name === this.root_current
      })
      if (this.main_current) {
        const main_hot_list =
          current_arr &&
          current_arr[0].mainLists.filter((el) => {
            return el.name === this.main_current
          })
        return main_hot_list && main_hot_list[0].hotProducts
      } else {
        return current_arr && current_arr[0].hotProducts
      }
    },
    sub_current_list: function () {
      if (!this.main_current) return
      const current_arr = this.main_current_list.mainLists.filter((item) => {
        return item.name === this.main_current // 取得陣列中雙數的物件
      })
      return current_arr && current_arr[0].subLists
    },
  },
  watch: {
    // watching nested property
  },
  created() {
    this.banner_menu = bannerMenu
  },
  mounted() {
    const vthis = this
    this.$nextTick(() => {
      mainSlick('.slick1')

      $('.auction_area .slick1').on(
        'afterChange',
        function (event, slick, currentSlide, nextSlide) {
          var img_src = $(`[data-slick-index=${currentSlide}]`)
            .find('.pc')
            .attr('src')
          $('.slick1')
            .next('.bg_blur')
            .css({ backgroundImage: `url(${img_src})` })
        }
      )

      regularSlick({
        el: '.slick3_1',
        slidesToShow: 3,
        extraSetting: this.slick_setting3,
      })

      regularSlick({
        el: '.slick4_3',
        slidesToShow: 4,
        extraSetting: { infinite: true, ...this.slick_setting2 },
      })

      regularSlick({
        el: '.slick3_2_1',
        slidesToShow: 3,
        extraSetting: this.slick_setting2_1,
      })

      regularSlick({
        el: '.slick_time',
        infinite: true,
        slidesToShow: 4,
        variableWidth: true,
        extraSetting: {
          responsive: [
            {
              breakpoint: 999,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 599,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        },
      })

      $('#todayfocus').slick({
        infinite: true,
        dots: true,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      })
      goToTopHandler()

      $('#app').addClass('show')

      $('.menu_wrapper ul').each(function (index) {
        var width_setting = $(this)[0].children.length
        vthis.subject_length[index] = $(this)[0].children.length
        $(this).css({ width: 100 * width_setting + 'px' })
      })

      // var endDate = new Date('08/15/2022 10:00 AM')
      // layoutJS.counterDate(endDate)
    })
  },
  methods: {
    // submit form handler
    submit: function () {
      this.submitted = true
    },
    menuHandler: function (type, name) {
      switch (type) {
        case 'root':
          this.root_current = name
          this.main_current = null
          break
        case 'main':
          this.main_current = name
          break
        case 'out':
          this.main_current = this.root_current = this.sub_current = null
          break
        default:
      }
    },
    areaMenuSetting: function (type) {
      var $menu = $('#subject' + type).find('.menu')
      var outerWidth = $menu.innerWidth()
      var innerWidth = $menu.find('ul').innerWidth()
      if (innerWidth - outerWidth <= 20) {
        $menu.find('ul').addClass('noLeft')
      } else {
        $menu.find('ul').removeClass('noLeft')
      }
    },
    areaHandler: function (type, index, arrow) {
      this.areaMenuSetting(type)
      if (arrow) {
        var addNum = this.current_subject[type] + index
        var length = this.subject_length[type]
        var newIndex =
          addNum < 0 ? 0 : addNum > length - 1 ? length - 1 : addNum
        this.current_subject[type] = newIndex
      } else {
        this.current_subject[type] = index
      }
      var fixedHeight = $('#subject' + type).innerHeight() + 2
      $('#subject' + type).css({ height: fixedHeight })

      $('#subject' + type)
        .find('ul.detail')
        .addClass('opa0')
      $('.subject_slick' + type).slick('unslick')

      setTimeout(() => {
        if (isMobile()) {
          $(`.subject_slick${type}`)
            .find('.db_veiw')
            .css({ 'min-width': $(window).innerWidth() / 2 - 41 })
        }
        regularSlick({
          el: '.subject_slick' + type,
          slidesToShow: 4,
          extraSetting: { infinite: true, ...this.slick_setting2 },
        })
        $('.subject_slick' + type).slick('resize')
      }, 200)
      setTimeout(() => {
        $('#subject' + type)
          .find('ul.detail')
          .removeClass('opa0')
        $('#subject' + type).css({ height: 'initial' })
      }, 300)
    },
  },
})
